import { IoIosArrowBack } from "react-icons/io";
import style from "./LeftArrow.module.css";

const LeftArrow = ({ onClick }) => {
  return (
    <button
      onClick={() => onClick()}
      className={[style.btn, style.btnLeft].join(" ")}
    >
      <IoIosArrowBack />
    </button>
  );
};
export default LeftArrow;
